import React from 'react';
import { CardActions, Card, CardContent, Typography } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import Skeleton from '@mui/material/Skeleton';
import Chip from 'Components/Chip';
import { CardMain, CardActionStyle, CardMediaStyle, CardStyle } from './style';

export default function MediaControlCard({ card = [] }) {
  return (
    <Card sx={CardStyle}>
      <Skeleton variant="rectangular" width={210} height={168} />{' '}
      <div style={CardMain}>
        <CardContent>
          <Typography gutterBottom fontSize="1em">
            <Skeleton variant="text" width={200} />
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <Skeleton variant="text" width={200} />
          </Typography>
        </CardContent>
        <CardActions style={CardActionStyle}>
          <Chip style={{ border: 'none' }}>
            <PersonOutlineOutlinedIcon style={{ marginTop: '-.4rem' }} />
            <Skeleton variant="text" width={174} />
          </Chip>
        </CardActions>
      </div>
    </Card>
  );
}
